import React from 'react';
import { Grid } from '@material-ui/core';
import { PricingDashboardPropTypes } from '../../../../../interfaces/iproptypes';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import ListingView from './ListingView';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#f7f8fb',
    marginTop: -40,
    display: 'flex',
    flexDirection: 'column',
    padding: '40px'
  },
  mobileAlert: {
    marginTop: 100,
    width: 240,
    height: 120,
  },
}));

const PricingDashboard = ({
  totalNumberOfListings,
  search,
  bookingChanges,
  filteredBookings,
  getBookingChanges,
  compsetFilterVal,
  setCompsetFilterVal,
  page,
  setPage,
  filterTriggered,
  compsets,
  compset,
  compsetListingIDs,
  getCompsetListingIdsLoadStart,
  setCompsetListingIds,
  compsetCRUD,
  compsetID,
  idle,
  setIdle,
  setFilterOpen,
  deletedRows,
  setDeletedRows,
  currentCompsetID,
  setCurrentCompsetID,
  currentCompsetName,
  setCurrentCompsetName,
  matches,
  currency,
}: PricingDashboardPropTypes) => {
  const classes = useStyles();

  return (
    <Grid container item xs={12} md={12} lg={12} className={classes.root}>
      {matches ? (
        <Grid container direction="column" alignItems="center">
          <Alert severity="error" className={classes.mobileAlert}>
            Our CompSet feature currently doesn't support mobile devices. We'd love to show this
            feature to you. Could you please visit us with desktop or laptop?
          </Alert>
        </Grid>
      ) : (
        <ListingView
          bookingChanges={bookingChanges}
          filteredBookings={filteredBookings}
          search={search}
          totalNumberOfListings={totalNumberOfListings}
          getBookingChanges={getBookingChanges}
          compsetFilterVal={compsetFilterVal}
          setCompsetFilterVal={setCompsetFilterVal}
          page={page}
          setPage={setPage}
          filterTriggered={filterTriggered}
          compsets={compsets}
          compset={compset}
          compsetListingIDs={compsetListingIDs}
          getCompsetListingIdsLoadStart={getCompsetListingIdsLoadStart}
          setCompsetListingIds={setCompsetListingIds}
          compsetCRUD={compsetCRUD}
          compsetID={compsetID}
          idle={idle}
          setIdle={setIdle}
          setFilterOpen={setFilterOpen}
          deletedRows={deletedRows}
          setDeletedRows={setDeletedRows}
          currentCompsetID={currentCompsetID}
          setCurrentCompsetID={setCurrentCompsetID}
          currentCompsetName={currentCompsetName}
          setCurrentCompsetName={setCurrentCompsetName}
          currency={currency}
        />
      )}
    </Grid>
  );
};

export default PricingDashboard;
